/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `PREMIUM_ANNUAL` - PREMIUM_ANNUAL * `PREMIUM_MONTHLY` - PREMIUM_MONTHLY * `STANDARD_ANNUAL` - STANDARD_ANNUAL * `STANDARD_MONTHLY` - STANDARD_MONTHLY * `BASE_ANNUAL` - BASE_ANNUAL * `BASE_MONTHLY` - BASE_MONTHLY * `LITE_ANNUAL` - LITE_ANNUAL * `LITE_MONTHLY` - LITE_MONTHLY * `ENTERPRISE_ANNUAL` - ENTERPRISE_ANNUAL * `ENTERPRISE_MONTHLY` - ENTERPRISE_MONTHLY * `AGENT_ANNUAL` - AGENT_ANNUAL * `AGENT_MONTHLY` - AGENT_MONTHLY
 * @export
 * @enum {string}
 */
export enum PlanEnum {
    PremiumAnnual = 'PREMIUM_ANNUAL',
    PremiumMonthly = 'PREMIUM_MONTHLY',
    StandardAnnual = 'STANDARD_ANNUAL',
    StandardMonthly = 'STANDARD_MONTHLY',
    BaseAnnual = 'BASE_ANNUAL',
    BaseMonthly = 'BASE_MONTHLY',
    LiteAnnual = 'LITE_ANNUAL',
    LiteMonthly = 'LITE_MONTHLY',
    EnterpriseAnnual = 'ENTERPRISE_ANNUAL',
    EnterpriseMonthly = 'ENTERPRISE_MONTHLY',
    AgentAnnual = 'AGENT_ANNUAL',
    AgentMonthly = 'AGENT_MONTHLY'
}



